module.exports = __webpack_public_path__ + "static/media/jaels-creations-thumbnail.e63f384b.png";